import { render, staticRenderFns } from "./DebtorMessages.vue?vue&type=template&id=89011416&"
import script from "./DebtorMessages.vue?vue&type=script&lang=js&"
export * from "./DebtorMessages.vue?vue&type=script&lang=js&"
import style0 from "./DebtorMessages.vue?vue&type=style&index=0&id=89011416&prod&lang=css&"
import style1 from "./DebtorMessages.vue?vue&type=style&index=1&id=89011416&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DebtorMessages.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports